"use client";

import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";


export function DataTableViewOptions({
}) {
  const navigate = useNavigate();
  return (
    <div className="flex gap-4">
      <Button
        // variant="outline"
        onClick={() =>
          navigate("/retaguarda-de-loja/requisicao-de-acesso/criar")
        }
        size="sm"
        className="ml-auto hidden h-8 lg:flex"
      >
        <Plus />
        Solicitar novo acesso
      </Button>
    </div>
  );
}